require('./mortgageRequestOperativeDocumentation.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const MortgageRequestOperativeDocumentationBlock = require('./mortgageRequestOperativeDocumentationBlock');

// @ constants
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');

// @ actions
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');


class MortgageRequestOperativeDocumentation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.requestSummaryDocumentation();
    }

    getDocument(documentType, documentLabel, replaceable = false) {
        const { summaryDocumentationState } = this.props;

        const docResult = summaryDocumentationState.get('data').filter(doc => {
            return doc.get('tipoDocumentoId') === documentType;
        });

        return {
            documentLabel: `mortgageRequestOperativeDocumentation-${documentLabel}`,
            documentStatus: docResult.getIn([0, 'estado']) || DOCUMENTS_STATUS.NONE,
            documentType: documentType,
            replaceable: replaceable
        };
    }

    getDocuments() {
        const documents = {
            insuranceDocuments: [
                this.getDocument(DOCUMENTS_TYPES.INSURANCE_POLICY, 'insurancePolicy'),
                this.getDocument(DOCUMENTS_TYPES.RECIB_HOGAR, 'activeInsurance', true)
            ],
            livingPlaceDocuments: [
                this.getDocument(DOCUMENTS_TYPES.REGISTERED_NS, 'registeredSimpleNote')
            ],
            contractDocuments: [
                this.getDocument(DOCUMENTS_TYPES.SIGNED_PRECONTRACTUAL, 'signedPrecontractualDocs'),
                this.getDocument(DOCUMENTS_TYPES.LOAN_WRITING, 'loanWriting')
            ],
            expensesDocuments: [
                this.getDocument(DOCUMENTS_TYPES.EXPENSES_BILL, 'expensesBill')
            ]
        };

        return documents;
    }

    render() {
        const { summaryDocumentationState } = this.props;

        if (!summaryDocumentationState.get('documentsRequested') && summaryDocumentationState.get('isFetching')) {
            return <LoadingSection />;
        }

        const documents = this.getDocuments();

        return (
            <div className="mortgage-request-operative-documentation">
                <div className="row">
                    <div className="col-md-12">
                        <MortgageRequestOperativeDocumentationBlock
                            titleKey="mortgageRequestOperativeDocumentation-homeInsuranceBlockTitle"
                            documents={documents.insuranceDocuments}
                        />
                        <MortgageRequestOperativeDocumentationBlock
                            titleKey="mortgageRequestOperativeDocumentation-livingPlaceDocsBlockTitle"
                            documents={documents.livingPlaceDocuments}
                        />
                        <MortgageRequestOperativeDocumentationBlock
                            titleKey="mortgageRequestOperativeDocumentation-contractDocsBlockTitle"
                            documents={documents.contractDocuments}
                        />
                        <MortgageRequestOperativeDocumentationBlock
                            titleKey="mortgageRequestOperativeDocumentation-billsBlockTitle"
                            documents={documents.expensesDocuments}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestOperativeDocumentation.propTypes = {
    summaryDocumentationState: PropTypes.object,
    requestSummaryDocumentation: PropTypes.func
}

module.exports.constructor = MortgageRequestOperativeDocumentation;

module.exports.MortgageRequestOperativeDocumentation = connect(state => ({
    summaryDocumentationState: state.mortgageRequestSummaryDocumentation
}), {
    requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation
})(MortgageRequestOperativeDocumentation);